import React from 'react';
import "./Pagination.css";

const Pagination = ({ nPages, currentPage, handlePagination }) => {

    const pageNumbers = [...Array(nPages + 1).keys()].slice(1)


    const nextPage = () => {
            if(currentPage !== nPages) handlePagination(currentPage + 1)
    }
    const prevPage = () => {
        if(currentPage !== 1) handlePagination(currentPage - 1)
    }
    return (
        <nav >
            <ul className='pagination justify-content-center' >
                <li className="page-item">
                    <a className="page-link" 
                        onClick={prevPage} 
                        href='#'>
                        
                        Previous
                    </a>
                </li>
                {pageNumbers.map(pgNumber => (
                    <li key={pgNumber} 
                        className= {`page-item ${currentPage == pgNumber ? 'active' : ''} `} >

                        <a onClick={() => handlePagination(pgNumber)}  
                            className='page-link' 
                            href='#'>
                            
                            {pgNumber}
                        </a>
                    </li>
                ))}
                <li className="page-item">
                    <a className="page-link" 
                        onClick={nextPage}
                        href='#'>
                        
                        Next
                    </a>
                </li>
            </ul>
        </nav>
    )
}

export default Pagination;